import React from 'react';
import Navbar from '../components/client/Navbar';
import Footer from '../components/client/Footer';

const ClientLayout = ({ children }) => {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />

      {/* Contenu principal */}
      <main className="">
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ClientLayout; 